import { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import PageContext from './PageContext';
import validateInputArray from '../functions/validateInputArray';
import dynamicTransformation from '../functions/dynamicTransformation';
import dynamicValidation from '../functions/dynamicValidation';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const AddSubCompanyModal = () =>{
    // get context from parent
    const {
        addSubCompanyModal, 
        setAddSubCompanyModal,
        masterCompanyData,
        getCompanyDetailsData,  
        snackbarAlert,   
        // processorDefaultData, 
        // editableBillingRate, 
        // editableProcessor, 
        subCompanyLevelConfig, 
        subCompanyLevelLists,
    } = useContext(PageContext);
    // initialize http context 
    const {
        POST, 
    } = useContext(HttpContext);
    // get persistant redux global state from store
    const company = useSelector((state) => state.company);
    // initialize state 
    const [values, setValues] = useState({}); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);

    // // set processor to default using portfolio and processorDefaultData
    // const defaultProcessor = () => {
    //     for (let i = 0; i < processorDefaultData.length; i++){
    //         if (portfolio == processorDefaultData[i]['incentivetype']){
    //             setProcessor(processor => processor = processorDefaultData[i]['processorid']); 
    //             break; 
    //         }
    //     }
    // }

    // event handler for submit click
    const onSubmitClick = () =>{
        return new Promise((resolve, reject) => {
            // destructure values to pass by value
            let requestValues = [{...values}]; 
            // validate input
            let checkError = validateInputArray(
                requestValues, 
                subCompanyLevelConfig,
                dynamicValidation,
                subCompanyLevelLists, 
                snackbarAlert,  
                error, 
                setError, 
                dynamicTransformation, 
                {},
            ); 
            // exit request if error 
            if (checkError) {
                reject(); 
                return; 
            }
            // add mastercompanyid to requestValues 
            requestValues[0]['mastercompanyid'] = masterCompanyData['mastercompanyid'];
            // make post request to insert data into aurora db
            let response; 
            POST('/client/subCompanyData', {
                ...requestValues[0] 
            }).then(res => {
                console.log(res);
                response = res; 
                // hide modal
                setAddSubCompanyModal(addSubCompanyModal => addSubCompanyModal = false);
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh company details page using function from parent
                return getCompanyDetailsData(company);
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            }); 
        });  
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (subCompanyLevelConfig){
            setConfig(config => config = subCompanyLevelConfig); 
            // set default value 
            let temp = {}; 
            for (let i = 0; i < subCompanyLevelConfig.length; i++ ) {
                if (subCompanyLevelConfig[i]['columnid'] == 'startdate') {
                    temp['startdate'] = new Date(); 
                }
                if (subCompanyLevelConfig[i]['columnid'] == 'enddate') {
                    temp['enddate'] = null; 
                }
                else if (subCompanyLevelConfig[i]['columnid'] == 'active') {
                    temp['active'] = subCompanyLevelLists['active'][0]; 
                }   
            }
            setValues(values => values = temp); 
        }
    }, [subCompanyLevelConfig]); 

    return(
        <> 
            <CCOffcanvas
                title='Add Sub Company'
                show={addSubCompanyModal}
                onCanvasClose={()=>setAddSubCompanyModal(addSubCompanyModal => addSubCompanyModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                            {config.map((el) => 
                                el['add'] == true ?
                                <>
                                    <div>
                                        <DynamicPageInput 
                                            data={values} 
                                            setData={setValues} 
                                            config={el} 
                                            args={subCompanyLevelLists} 
                                            width={'100%'} 
                                            showError={error[0][el['columnid']]}
                                            topAlignTypography={true}
                                        />
                                    </div>
                                </>
                                : <></>
                            )}
                        </div>
                        {/* button to submit sub company */}
                        <div
                                className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                            >
                            <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={()=>setAddSubCompanyModal(addSubCompanyModal => addSubCompanyModal = false)}
                            />
                            <ApiRequestButton onButtonClick={onSubmitClick} />  
                        </div>
                    </div>
            </CCOffcanvas>
        </>
    );
}

export default AddSubCompanyModal;